import clsx from 'clsx'
import { Chip as MuiChip, makeStyles } from '@material-ui/core'
import { pascalCase } from 'pascal-case'
import PropTypes from 'prop-types'
import React from 'react'

const extendedColors = ['lightGreen', 'darkGreen', 'purple', 'orange']

const useStyles = makeStyles(theme => ({
  root: {
    height: 'auto',
    minHeight: 32,
    paddingTop: 7,
    paddingBottom: 7,
  },
  rootSmall: {
    minHeight: 24,
    paddingTop: 3,
    paddingBottom: 3,
  },
  label: {
    whiteSpace: 'normal',
  },
  // https://github.com/mui-org/material-ui/blob/fad48de8f7d9a449adb4ab9796e9ed1c2c0593ca/packages/material-ui/src/Button/Button.js#L131
  ...extendedColors.reduce((colorStyles, colorName) => {
    colorStyles[`color${pascalCase(colorName)}`] = {
      color: theme.palette[colorName].contrastText,
      backgroundColor: theme.palette[colorName].main,
      '&:focus': {
        backgroundColor: theme.palette[colorName].main,
      },
    }
    colorStyles[`clickable${pascalCase(colorName)}`] = {
      '&:focus,&:hover': {
        backgroundColor: theme.palette[colorName].dark,
      },
    }
    return colorStyles
  }, {}),
}))

export const Chip = ({ className, color, size, ...props }) => {
  const classes = useStyles()
  const extendedColor = extendedColors.includes(color)
  return (
    <MuiChip
      color={extendedColor ? undefined : color}
      classes={{
        clickable: extendedColor && classes[`clickable${pascalCase(color)}`],
        label: classes.label,
        root: clsx(
          extendedColor && classes[`color${pascalCase(color)}`],
          classes.root,
          size === 'small' && classes['rootSmall'],
          className
        ),
      }}
      size={size}
      {...props}
    />
  )
}

Chip.propTypes = {
  color: PropTypes.oneOf(['primary', 'secondary', ...extendedColors]),
  size: PropTypes.oneOf(['small', 'medium']),
}

Chip.defaultProps = {
  size: 'medium',
}

export default Chip
